import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Mutation } from 'react-apollo';

import { AuthConsumer } from '../../../context/auth';

import mutations from '../../../graphql/mutations';

import { formatErrors } from '../../../helpers';

import style from './index.module.scss';

const {
  authMutations: { SIGNUP },
} = mutations;

class SignupForm extends Component {
  state = {
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    errors: [],
  };

  onChange = e =>
    this.setState({
      [e.target.name]: e.target.value,
    });

  onSignup = async (e, signupUser, handleAuthentication) => {
    e.preventDefault();

    const { firstname, lastname, email, password, errors } = this.state;

    if (errors.length === 0) {
      const {
        data: {
          signupUser: { user, token },
        },
      } = await signupUser({
        variables: {
          input: {
            firstname: firstname.trim(),
            lastname: lastname.trim(),
            email: email.trim(),
            password: password.trim(),
          },
        },
      });

      if (token && user) {
        handleAuthentication(true, user);

        localStorage.setItem('quora-token', token);
        localStorage.setItem('current-user', JSON.stringify(user));

        this.setState({
          firstname: '',
          lastname: '',
          email: '',
          password: '',
          errors: [],
        });
      }
    }
  };

  render() {
    const { firstname, lastname, email, password } = this.state;
    const {
      changeSignupMethod,
      location: { pathname },
    } = this.props;

    return (
      <div className={style.signup}>
        <p className={style['signup-heading']}>Sign Up</p>
        <Mutation mutation={SIGNUP}>
          {(signupUser, { loading, error }) => (
            <AuthConsumer>
              {({ handleAuthentication }) => (
                <form
                  className={style['signup-form']}
                  onSubmit={e =>
                    this.onSignup(e, signupUser, handleAuthentication)
                  }
                >
                  <div className='row'>
                    <div className={`col-6 ${style['col-6']}`}>
                      <input
                        className={`form-control ${style['form-control']}`}
                        type='text'
                        name='firstname'
                        value={firstname}
                        placeholder='First Name'
                        onChange={this.onChange}
                      />
                    </div>
                    <div className={`col-6 ${style['col-6']}`}>
                      <input
                        className={`form-control ${style['form-control']}`}
                        type='text'
                        name='lastname'
                        value={lastname}
                        placeholder='Last Name'
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <input
                    className={`form-control ${style['form-control']}`}
                    type='email'
                    name='email'
                    value={email}
                    placeholder='Email'
                    onChange={this.onChange}
                  />
                  <input
                    className={`form-control ${style['form-control']}`}
                    type='password'
                    name='password'
                    value={password}
                    placeholder='Password'
                    onChange={this.onChange}
                  />
                  {error && (
                    <>
                      {formatErrors(error.graphQLErrors).map(
                        (errorMsg, index) => (
                          <p key={index} className={style['error-msg']}>
                            {errorMsg}
                          </p>
                        )
                      )}
                    </>
                  )}
                  <div className={`row ${style.buttons}`}>
                    <button
                      type='button'
                      className={`btn btn-cancel ${style.btn} ${
                        style['btn-cancel']
                      }`}
                      onClick={changeSignupMethod}
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className={`btn btn-primary ${style.btn} ${
                        style['btn-primary']
                      }`}
                      disabled={error}
                    >
                      {loading ? <i className='fas fa-spinner' /> : 'Sign Up'}
                    </button>
                  </div>
                </form>
              )}
            </AuthConsumer>
          )}
        </Mutation>
        {pathname !== '/' && (
          <p className={style['login-propmt']}>
            Already got an account? <Link to='/auth/login'>Log in</Link>
          </p>
        )}
      </div>
    );
  }
}

SignupForm.propTypes = {
  changeSignupMethod: PropTypes.func,
};

export default withRouter(SignupForm);
